import { CREATE } from 'permissions/actions'

export const DOCUMENT_TEMPLATE = '@@permissions/documentTemplate/policy'

export default {
  [CREATE]: user => user.is_account_admin
}
